import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-secondary-900" role="contentinfo">
      <div className="px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
                <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                  <i className="ri-play-circle-fill text-background-50 text-xl"></i>
                </div>
                <span className="font-heading text-lg font-bold text-background-50 whitespace-nowrap">
                  西瓜视频
                </span>
              </Link>
              <p className="text-secondary-400 text-sm leading-relaxed">
                {t('footer.description')}
              </p>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
                快速导航
              </h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/" className="text-secondary-400 hover:text-background-50 text-sm transition-colors cursor-pointer">
                    {t('nav.home')}
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-secondary-400 hover:text-background-50 text-sm transition-colors cursor-pointer">
                    {t('nav.about')}
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
                视频分类
              </h4>
              <ul className="space-y-2.5">
                {categories.slice(0, 4).map((cat) => (
                  <li key={cat.id}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-secondary-400 hover:text-background-50 text-sm transition-colors cursor-pointer"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
                更多
              </h4>
              <ul className="space-y-2.5">
                {categories.slice(4).map((cat) => (
                  <li key={cat.id}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-secondary-400 hover:text-background-50 text-sm transition-colors cursor-pointer"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
                <li>
                  <a href="#" className="text-secondary-400 hover:text-background-50 text-sm transition-colors cursor-pointer">
                    {t('footer.terms')}
                  </a>
                </li>
                <li>
                  <a href="#" className="text-secondary-400 hover:text-background-50 text-sm transition-colors cursor-pointer">
                    {t('footer.privacy')}
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-secondary-700/50">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              <p className="text-secondary-500 text-sm">
                {t('footer.copyright')}
              </p>
              <div className="flex items-center gap-2">
                <span className="text-secondary-500 text-sm">
                  {t('site.slogan')}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}